import fetch from '@/utils/fetch';
const Gateway = '/oauth2'
const ApiPath = '/api'
const PathPer = ApiPath+Gateway

/**
 * get 示例 post 改 method  body传参方式 用 data:query
 * /
// export function get(query) {
//     return fetch({
//         url: PathPer + '',
//         method: 'get',
//         params: query
//     });
// }
/**
 * 文件上传示例
 */
// export function upload(files){
//     return fetch({
//         url: PathPer + '/evaluation/file/upload',
//         method: 'post',
//         headers: {
//             "Content-Type": "multipart/form-data"
//         },
//         data: files
//     })
// }
/**
 * 密码登录
 */
export function loginPwdInfo(query) {
    return fetch({
      url: PathPer + '/login/userLogin',
      method: 'post',
      params: query,
    });
  }
/**
 * 验证码登录
 */
export function codeLoginInfo(query) {
    return fetch({
      url: PathPer + '/login/codeLogin',
      method: 'get',
      params: query,
    });
  }
/**
 * 代理登录
 */
export function agentLoginInfo(query) {
    return fetch({
      url: PathPer + '/login/agent',
      method: 'post',
      params: query,
    });
  }
/**
 * 小店代理登录（新接口）
 */
export function smallShopAgentLogin(query) {
    return fetch({
      url: PathPer + '/login/shop/agent',
      method: 'post',
      params: query,
    });
  }
/**
 * 代理登录切换回运营
 */
export function switchBackLoginInfo(query) {
    return fetch({
      url: PathPer + '/login/switchBack',
      method: 'post',
      params: query,
    });
  }
/**
 * 微信登录
 */
export function wechatLoginInfo(query) {
    return fetch({
      url: PathPer + '/login/wechatLogin',
      method: 'get',
      params: query,
    });
  }
/**
 * 微信注册
 */
export function wechatRegisterInfo(query) {
    return fetch({
      url: PathPer + '/login/openIdLogin',
      method: 'post',
      params: query,
    });
  }
/**
 * 刷新访问令牌
 */
export function refreshTokenInfo(query) {
    return fetch({
      url: PathPer + '/login/refreshToken',
      method: 'post',
      params: query,
    });
  }
/**
 * 获取微信用户信息
 */
export function wechatLoginUserInfo(query) {
    return fetch({
      url: PathPer + '/login/userinfo',
      method: 'get',
      params: query,
    });
  }
